import React, { useEffect } from "react";
import "./index.scss";
import { setResponsiveImage } from "../../helpers";

type HeaderType = {
  subheading?: string;
  heading?: string;
  imageUrlTop?: string;
  imageUrlBottom?: string;
  imageUrlTopMobile?: string;
  imageUrlBottomMobile?: string;
  postScript?: string;
};

const updateImageUrl = ({
  url = "",
  width,
  height
}: {
  url: string | undefined;
  width: number;
  height: number;
}) => {
  const heightStr = url.slice(url.indexOf("height=")).split("&")[0];
  const widthStr = url.slice(url.indexOf("width=")).split("&")[0];

  return url
    .replace(heightStr, `height=${height}`)
    .replace(widthStr, `width=${width}`);
};

export default ({
  subheading = "",
  heading = "",
  imageUrlTop = "./",
  imageUrlBottom = "./",
  postScript = "",
  imageUrlTopMobile,
  imageUrlBottomMobile
}: HeaderType) => {
  useEffect(() => {
    setResponsiveImage({
      elClassName: "hall-of-champions__images-top",
      mobileImage: updateImageUrl({
        url: imageUrlTopMobile,
        height: 670,
        width: 320
      }),
      tabletImage: updateImageUrl({
        url: imageUrlTop,
        height: 350,
        width: 500
      }),
      desktopImage: updateImageUrl({
        url: imageUrlTop,
        height: 395,
        width: 690
      })
    });
    setResponsiveImage({
      elClassName: "hall-of-champions__images-bottom",
      mobileImage: updateImageUrl({
        url: imageUrlBottomMobile,
        height: 650,
        width: 600
      }),
      tabletImage: updateImageUrl({
        url: imageUrlBottom,
        height: 270,
        width: 744
      }),
      desktopImage: updateImageUrl({
        url: imageUrlBottom,
        height: 290,
        width: 1080
      })
    });
  }, []);

  return (
    <div className="hall-of-champions__wrapper">
      <div className="hall-of-champions__header">
        <div className="hall-of-champions__heading">
          <div className="container">
            <div className="hall-of-champions__heading-main">
              <h1>
                <span>{subheading}</span>
                <p>{heading}</p>
              </h1>
            </div>
            <div className="hall-of-champions__heading-postscript">
              <h2>{postScript}</h2>
            </div>
          </div>
        </div>
        <div className="hall-of-champions__images">
          <div className="hall-of-champions__images-top"></div>
          <div className="hall-of-champions__images-bottom"></div>
        </div>
      </div>
    </div>
  );
};
